<template>
  <div>
    <ValidationObserver ref="form">
      <form @submit.prevent="validate">
        <div class="row mb-3">
          <div class="col-12">
            <ValidationProvider
              name="deliveryStyle"
              rules="required"
            >
              <fg-input
                slot-scope="{ errors }"
                :error="errors[0] ? 'Please select whether this is a Weeklong or 2-Weekend course.': ''"
              >
                <label>Delivery Style <span class="text-danger">*</span></label>
                <el-select
                  class="select-default2"
                  size="large"
                  name="deliveryStyle"
                  placeholder=""
                  v-model="courseSetupInfo.DeliveryStyle"
                >
                  <el-option
                    class="select-default2"
                    value="1"
                    label="1 Week"
                  />
                  <el-option
                    class="select-default2"
                    value="2"
                    label="2 Weekends"
                  />
                </el-select>
              </fg-input>
            </ValidationProvider>
          </div>
        </div>
        <div
          class="form-row"
          v-if="courseSetupInfo.DeliveryStyle === '2'"
        >
          <div class="col-6">
            <div class="form-group">
              <span class="font-weight-bold">Weekend #1</span>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <span class="font-weight-bold">Weekend #2</span>
            </div>
          </div>
        </div>
        <div
          class="form-row"
          v-if="courseSetupInfo.DeliveryStyle === '2' || courseSetupInfo.DeliveryStyle === '1'"
        >
          <div class="col-6">
            <div class="form-group">
              <ValidationProvider
                name="startDate1"
                rules="required"
              >
                <fg-input
                  slot-scope="{ errors }"
                  :error="errors[0] ? 'Start Date is Required.': ''"
                >
                  <label>Start Date <span class="text-danger">*</span></label>
                  <el-date-picker
                    v-model="courseSetupInfo.Session1StartDate"
                    type="date"
                    name="startDate1"
                    value-format="yyyy-MM-ddTHH:mm:ss"
                    placeholder=""
                  />
                </fg-input>
              </ValidationProvider>
            </div>
          </div>
          <div class="col-6">
            <div
              class="form-group"
              v-if="courseSetupInfo.DeliveryStyle === '2'"
            >
              <ValidationProvider
                name="startDate2"
                rules="required_if:deliveryStyle,2"
              >
                <fg-input
                  slot-scope="{ errors }"
                  :error="errors[0] ? 'Start Date is Required.': ''"
                >
                  <label>Start Date <span class="text-danger">*</span></label>
                  <el-date-picker
                    v-model="courseSetupInfo.Session2StartDate"
                    type="date"
                    name="startDate2"
                    value-format="yyyy-MM-ddTHH:mm:ss"
                    placeholder=""
                  />
                </fg-input>
              </ValidationProvider>
            </div>
          </div>
        </div>
        <div
          class="form-row"
          v-if="courseSetupInfo.DeliveryStyle === '2' || courseSetupInfo.DeliveryStyle === '1'"
        >
          <div class="col-6">
            <ValidationProvider
              name="locationName1"
              rules="required|max:255"
              v-slot="{ passed, failed }"
            >
              <fg-input
                name="locationName1"
                :error="failed ? 'The Location Name is required': null"
                :has-success="passed"
                required
                label="Location Name"
                placeholder=""
                max-length="255"
                v-model="courseSetupInfo.Location1Name"
              />
            </ValidationProvider>
          </div>
          <div
            class="col-6"
            v-if="courseSetupInfo.DeliveryStyle === '2'"
          >
            <ValidationProvider
              name="locationName2"
              rules="required_if:deliveryStyle,2|max:255"
              v-slot="{ passed, failed }"
            >
              <fg-input
                name="locationName1"
                :error="failed ? 'The Location Name is required': null"
                :has-success="passed"
                required
                label="Location Name"
                placeholder=""
                max-length="255"
                v-model="courseSetupInfo.Location2Name"
              />
            </ValidationProvider>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import { extend } from 'vee-validate'
// eslint-disable-next-line camelcase
import { required, required_if } from 'vee-validate/dist/rules'

extend('required', required)
extend('required_if', required_if)

export default {
  name: 'CourseCreationSessionInfo',
  data: function () {
    return {
      courseSetupInfo: {
        DeliveryStyle: null,
        Session1StartDate: null,
        Session2StartDate: null,
        Location1Name: null,
        Location2Name: null
      }
    }
  },
  methods: {
    validate: function () {
      return this.$refs.form.validate().then(res => {
        this.$emit('on-validated', res, 'courseSetupInfo', this.courseSetupInfo)
        return res
      })
    }
  }
}
</script>
